export default __webpack_public_path__ + "static/media/medical.4faebde0.png";